// 테마 헬퍼

// =================================================================================================
// 가져오기
// =================================================================================================
// 고정 영역

// 동적 영역
import nativeBaseBasicAppExtendTheme from 'src/com/keymansco/chihuahuaone/helper/nativeBaseBasicAppExtendTheme';

// =================================================================================================
// 상수
// =================================================================================================
// 네이티브베이스 앱 확장 테마
// const nativeBaseAppExtendTheme = nativeBaseBasicAppExtendTheme; // 네이티브베이스 앱 확장 테마 - 기본

// =================================================================================================
// 내보내기
// =================================================================================================
// export default {
//   nativeBaseAppExtendTheme: nativeBaseAppExtendTheme,
// };
export default nativeBaseBasicAppExtendTheme;
